<template>
  <div id="hotel-image">
    <div class="tab-header">
      <label class="tab-title">{{ $t("HOTEL_PHOTO") }}</label>
    </div>
    <div class="hotel-gallary">
      <image-gallary
        :uploadedFiles="hotelImages"
        :totalFiles="hotelImages.length"
        @setMainImage="setMainImage"
        @deleteImage="deleteImage"
        ref="imageGallary"
      >
        <button class="btn-icon add icon-plus" slot="upload-btn" @click="upload" />
      </image-gallary>
    </div>
    <upload-dialog
      :uploadDialog="true"
      :sourceFile="hotelImages"
      @uploadTargetImage="uploadTargetImage"
      ref="uploadComponent"
    >
      <div slot="header" class="tab-header">
        <label class="tab-title">{{ $t("LIBRARY") }}</label>
      </div>
    </upload-dialog>
  </div>
</template>

<script>
import UploadDialog from "@/components/Utils/UploadDialog.vue";
import ImageGallary from "@/components/GallaryManager/ImageGallary.vue";
import { service } from "@/_services/GeneralInfomation/hotel-image.service.js";
import { _alert } from "@/_helpers/function.js";

export default {
  components: {
    "image-gallary": ImageGallary,
    "upload-dialog": UploadDialog
  },
  props: {},
  data() {
    return {
      hotelImages: [],
      mainId: null,
      uploadDialog: false
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='2']")
      .classList.add("v-tab--active");
  },
  watch: {
    hotelImages(value) {
      this.mainId = value.length ? value[0].id : 0;
    }
  },
  computed: {},
  methods: {
    initialize() {
      service.get().then(res => {
        this.mainId = res.data.find(x => x.main)
          ? res.data.find(x => x.main).id
          : 0;
        if (this.mainId) this.hotelImages.push(res.data.find(x => x.main));
        this.hotelImages.push(...res.data.filter(x => !x.main));
      });
    },
    upload() {
      this.$refs.uploadComponent.open();
    },
    uploadTargetImage(data) {
      let listNewId = [];
      let temp = [...this.hotelImages];
      let listOldId = temp.map(x => {
        return x.id;
      });
      data.forEach(x => {
        if (!listOldId.includes(x.id)) temp.push(x);
        listNewId.push(x.id);
      });
      let params = {
        main:
          this.mainId || temp.map(x => x.id).filter(x => x != this.mainId)[0],
        images: temp.map(x => x.id).filter(x => x != this.mainId)
      };
      service.update(params).then(res => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          this.hotelImages = [...temp];
        }
      });
      // this.$refs.imageGallary.removeAllSelected();
    },
    setMainImage(data) {
      let params = {
        main: data[0].id,
        images: data.slice(1, data.length).map(x => x.id)
      };
      // console.log(params);
      service.update(params).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    deleteImage(listRemoveId) {
      let listNewItem = this.hotelImages.filter(
        x => !listRemoveId.includes(x.id)
      );
      if (!listNewItem.length) {
        listNewItem.push(this.hotelImages[0]);
      }
      let params = {
        main: listNewItem[0].id,
        images:
          listNewItem.length > 1
            ? listNewItem.slice(1, listNewItem.length).map(x => x.id)
            : [listNewItem[0].id]
      };
      service.update(params).then(res => {
        if (listNewItem.length > 1) {
          _alert(res, this.$t(res.data), false);
        }
        if (res.responseCode == 0) {
          this.hotelImages = listNewItem;
        }
      });
      if (listNewItem.length == 1) {
        let message = this.$t("MAIN_IMAGES_MUST_EXIST");
        if (this.hotelImages.length > 1) {
          setTimeout(function() {
            _alert(null, message, false);
          }, 1000);
        }
        else {
          _alert(null, message, false);
        }
      }
    }
  }
};
</script>
